import styled from 'styled-components'

const ExplicitConsentCheckboxUi = styled.input.attrs(() => ({
  type: 'checkbox',
}))``

export default ExplicitConsentCheckboxUi
